import Vue from 'vue'
import VueRouter from 'vue-router'
import boardLayout from '../layout/web/BoardIndex'
import webLayout from '../layout/web'
import mobileLayout from '../layout/mobile'
import adminMenuApi from '../api/admin/AdminMenu'
import store from '../store'
import AdminComponent from '../layout/admin'

Vue.use(VueRouter)

// 기본 router 정보
const staticRoute = [
  {
    path: '/',
    redirect: '/portal',
    components: {
      default: webLayout,
      mobile: mobileLayout
    },
    props : true,
    children: [
      {
        path: 'portal',
        name: 'portal',
        components: {
          default: () => import("../views/web/Main"),
          mobile: () => import("../views/mobile/Main"),
        },
        props : true,
        meta: {
          title: '지도서비스'
        }
      },
    ]
  },
  {
    path: '/board',
    components: {
      default: boardLayout,
    },
    children: [
      {
        path: '',
        name: 'board',
        components: {
          default: () => import("../views/web/Board"),
        },
        meta: {
          title: '지도서비스'
        }
      },
    ]
  },
  {
    path: '/single',
    name: 'single',
    component: () => import('../views/web/SingleView'),
    props (route) {
      const years = route.query.statYears || ''
      return {
        statItem: route.query.statItem,
        statYears: years === ''? [] : years.split('|')
      }
    }
  },
  {
    path: '/loginAdmin',
    name: 'AdminLogin',
    component: () => import('../views/admin/AdminLogin')
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('../views/common/Error')
  }
]

routerload()

async function routerload () {
  let adminCnt = 0
  let adminGubun = true
  const menuList = await adminMenuApi.selectAdminMenuList()

  // 메뉴 정보 불러오기
  menuList.forEach(menu => {
    let viewYn = true
    if (menu.level === '1') {
      if (menu.viewYn === 'N') {
        viewYn = false
      }
      const param = {
        // path: `${menu.menuPath}`,
        path: menu.menuPath,
        name: menu.menuNm,
        component: AdminComponent,
        meta: {
          visible: viewYn,
          menuId: menu.menuId
        },
        children: []
      }
      Vue.set(staticRoute, staticRoute.length, param)
      if(adminGubun) {
        adminCnt = staticRoute.length - 1
        adminGubun = false
      }
    } else {
      let viewYn = true
      if (menu.viewYn === 'N') {
        viewYn = false
      }
      const param = {
        path: menu.menuPath,
        name: menu.menuNm,
        component: () => import(`@/${menu.programPath}`),
        meta: {
          visible: viewYn,
          menuId: menu.menuId,
          component: () => import(`@/${menu.programPath}`)
        }
      }
      Vue.set(staticRoute[staticRoute.length - 1].children, staticRoute[staticRoute.length - 1].children.length, param)
    }
  })

  // admin path 설정 -임시
  // const adminPath = staticRoute[adminCnt].path + '/' + staticRoute[adminCnt].children[0].path
  // const adminRoute = {
  //   path: '/admin',
  //   name: 'AdminMain',
  //   redirect: adminPath,
  //   meta: {
  //     visible: false
  //   }
  // }
  // Vue.set(staticRoute, staticRoute.length, adminRoute)

  // 최종 router 설정
  router.addRoutes(staticRoute)
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  // base: publicPath,
  scrollBehavior: () => ({ y: 0 }),
  routes: staticRoute
})

router.beforeEach((to, from, next) => {
  const userToken = store.getters["adminStore/token"]
  const authMenus = store.getters["adminStore/authMenus"]
  const authGubun = store.getters["adminStore/authGubun"]
  const id = store.getters["adminStore/id"]

  if (to.fullPath.substring(0, 6) === '/admin') {
    if (userToken === null) {
      alert('로그인 후 이용해주세요.')
      router.push('/loginAdmin')
    } else {
      let goNext = false
      for (const authMenu of authMenus) {
        for (const authSub of authMenu.children) {
          const authPath = authMenu.path + '/' + authSub.path
          if (to.fullPath === authPath) {
            goNext = true
          }
        }
      }
      if (goNext) {
        next()
      } else {
        alert('해당 메뉴에 권한이 없습니다. 로그인페이지로 이동합니다.')
        store.dispatch('adminStore/logout', { id })
      }
    }
  } else if (to.fullPath === '/loginAdmin') {
    if (authGubun) {
      store.commit('adminStore/setFalseAuthGubun')
      router.go('/loginAdmin')
    } else {
      if (userToken != null) {
        router.push(store.getters["adminStore/adminMain"])
      } else {
        next()
      }
    }
  } else {
    next()
  }

})

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

export default router
